import React from "react";
import { Row, Col, message, Button, Space, Tooltip, Modal } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";

import { PlusOutlined, DeleteFilled, FileOutlined } from "@ant-design/icons";
import DeleteConfirm from "./DeleteConfirm";
import ListTable from "./ListTable";

import CompanyAutocomplete from "./CompanyAutocomplete";

import config from "../config";
import DriverGroupStore from "../store/DriverGroupStore";
import withRouter from "../withRouter";
import DriverGroupAdd from "./DriverGroupAdd";
import CompanyStore from "../store/CompanyStore";

class DriverGroupList extends React.Component {
    constructor(props) {
        super(props);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.driverGroupStore = new DriverGroupStore();
        this.companyStore = new CompanyStore(this);

        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            openConfirm: false,
            confirmLoading: false,
            companyId: "",
            loadData: 0,
            listDataUpdate: false,
            openGroupAddFom: false,
            drgId: "",
            companyVal_Lab: "",
        };
    }
    onEdit = async (record) => {
        const Id = record.drgId;

        if (Id) {
            this.context.viewStateStore.setDriverGroupStates({
                companyId: record.companyId,
            });
            await this.setState({ drgId: Id });
            await this.setState({ openGroupAddFom: true });
        }
    };


    async onDelete(record) {
        const response = await this.driverGroupStore.deleteRecord({
            drgId: record.drgId,
        });

        if (response?.data?.success === "S") {
            message.success(response.data.message);
            this.handleSearch();
        } else {
            message.error(response.data.message);
        }
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevState.listDataUpdate !== this.state.listDataUpdate) {
            const setDriverGroupStates =
                this.context.viewStateStore.driverGroupObject;

            await this.setState({ companyId: setDriverGroupStates.companyId });

            this.setState({ listDataUpdate: false });
        }
    }
    async componentDidMount() {
        // await this.driverGroupStore.loadData({ offset: 0, limit: 50 });
        if (
            Number(this.props.getUserData().isadmin) !== -1 &&
            Number(this.props.getUserData().isadmin) !== 3
        ) {
            await this.setState({
                companyId: this.props.getUserData().userCompanyId,
            });
            await this.setState({ userId: this.props.getUserData().userId });
            await this.handleSearch();
        }
        this.setState({ pageSize: 50 });

        this.columns = [
            {
                // title: "  Device",
                title: this.context.translate("_DRIVER_GROUP_NAME_"),
                dataIndex: "groupName",
                width: "80%",
                render: (value, record) => {
                    return (
                        <Link
                            onClick={(e) => {
                                e.preventDefault();
                                this.onEdit(record);
                            }}
                        >
                            <FileOutlined /> &nbsp;{value}
                        </Link>
                    );
                },
            },
            {
                title: this.context.translate("_ACTION_"),
                dataIndex: "Action",
                key: "Action",
                // fixed: 'right',
                width: "20%",
                render: (_, record) => {
                    return (
                        <>
                            <Space>

                                <DeleteConfirm
                                    onConfirm={(e) => {
                                        e.preventDefault();
                                        this.onDelete(record);
                                    }}
                                >
                                    <Link>
                                        <Tooltip
                                            // title="Remove Device"
                                            title={this.context.translate(
                                                "_FLEET_GROUP_GROUPLIST_DELETE_"
                                            )}
                                            color={config.tooltipColorDelete}
                                            placement="bottom"
                                        >
                                            <DeleteFilled style={{ color: config.deleteColor }} />
                                        </Tooltip>
                                    </Link>
                                </DeleteConfirm>
                            </Space>
                        </>
                    );
                },
            },
        ];
    }

    async handleTableChange(pagination, filters, sorter) {
        // console.log(pagination);
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        this.handleSearch();
    }

    async handleChange(comp) {
        await this.setState({
            companyId: comp.value,
            pageSize: 50,
            currentPage: 1,
        });
        const singleData = await this.companyStore.getCompanyDataById(comp.value);
        await this.setState({ companyVal_Lab: singleData });
        await this.handleSearch();
    }

    async handleSearch() {
        this.setState({ loading: true });
        await this.driverGroupStore.getDriveGroup({
            offset: (this.state.currentPage - 1) * this.state.pageSize,
            limit: this.state.pageSize,
            companyId: this.state.companyId,
        });
        await this.setState({ loadData: 1 });
    }
    responseMsg = async (resp) => {
        if (resp.data.success == "S") {
            message.success(resp.data.message);
            this.setState({ openGroupAddFom: false });
            this.setState({ listDataUpdate: true });
            await this.handleSearch();

        }
        else {
            message.error(this.context.translate(resp.data.message));
        }
    };

    closeModal = () => {
        this.setState({ openGroupAddFom: false, driverGroupId: "" });
    };

    render() {
        return (
            <>
                <div style={{ padding: 0 }}>
                    <Row className="headerFixed" style={{ height: "50px" }}>
                        <Col span={12}>
                            <div className="heading">
                                {this.context.translate("_DRIVER_GROUP_LIST_")}
                            </div>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                        >
                            <Space
                                style={{
                                    float:
                                        this.context.locale.direction == "ltr" ? "right" : "left",
                                }}
                            >
                                <Tooltip
                                    // title="Add"
                                    title={this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                                    placement="left"
                                    color={config.primaryColor}
                                >
                                    <Button
                                        className="addButton"
                                        icon={<PlusOutlined />}
                                        type="primary"
                                        onClick={() =>
                                            this.setState({
                                                openGroupAddFom: true,
                                                drgId: "",
                                            })
                                        }
                                    ></Button>
                                </Tooltip>
                            </Space>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        paddingTop: "10px",
                        paddingRight: "24px",
                        paddingLeft: "24px",
                    }}
                >
                    <Row className="listInputRow">
                        <Col span={16}>
                            <Space>
                                <CompanyAutocomplete
                                    // allowClear={true}
                                    value={
                                        this.state.companyVal_Lab ? this.state.companyVal_Lab : null
                                    }
                                    onChange={(value) => this.handleChange(value)}
                                    style={{ width: 200 }}
                                />
                            </Space>
                        </Col>
                        <Col span={8}>
                            <Space
                                style={{
                                    float:
                                        this.context.locale.direction == "ltr" ? "right" : "left",
                                }}
                            ></Space>
                        </Col>
                    </Row>

                    <ListTable
                        currentPage={this.state.currentPage}
                        pageSize={this.state.pageSize}
                        total={this.driverGroupStore?.total}
                        columns={this.columns}
                        dataSource={this.driverGroupStore?.driverGroupDrivers}
                        loading={this.driverGroupStore?.loading}
                        onChange={this.handleTableChange}
                    />
                </div>

                {this.state.openGroupAddFom && (
                    <Modal
                        bodyStyle={{ height: "645px" }}
                        className="formShowModal" //  {/* css class */}
                        // title="Device Details"
                        title={this.context.translate("_DRIVER_GROUP_ADD_")}
                        centered
                        open={this.state.openGroupAddFom}
                        footer={null}
                        onCancel={() => {
                            this.setState({ openGroupAddFom: false, drgId: "" });
                        }}
                        width={665}
                    >
                        <div>
                            <DriverGroupAdd
                                drgId={this.state.drgId}
                                companyId={this.state.companyId}
                                response={this.responseMsg}
                                closeModal={this.closeModal}
                            />
                        </div>
                    </Modal>
                )}
            </>
        );
    }
}
DriverGroupList.contextType = StoreContext;
export default observer(withRouter(DriverGroupList));
